import { format, parseISO } from 'date-fns'

export default ({ date, mask }) => (format(parseISO(date), mask))
